import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import type { ResetPasswordDto } from "~/data/user/reset-password.dto";

import { resetPassword } from "~/data/user/user.service";

import { Field } from "../shared/field";
import { Button } from "../shared/button";
import { InputPassword } from "../shared/input";

export function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const form = useForm<ResetPasswordDto>({
    defaultValues: {
      reset_password_token: searchParams.get("reset_password_token") ?? "",
    },
  });
  const mutation = useMutation({
    mutationFn: (dto: ResetPasswordDto) => resetPassword(dto),
  });

  return (
    <form
      onSubmit={form.handleSubmit((dto) =>
        mutation.mutate(dto, {
          onSuccess: () => {
            toast.success("Senha atualizada com sucesso!");
            navigate("/entrar");
          },
        })
      )}
      className="flex flex-col items-center w-full"
    >
      <h2 className="text-primary-1 text-2xl lg:text-3xl font-semibold mb-5 lg:mb-10 text-center">
        Informar nova senha
      </h2>

      <div className="w-[460px] max-w-full">
        <Field label="Senha" className="mb-2">
          <InputPassword
            {...form.register("password", {
              required: "Campo obrigatório",
            })}
            placeholder="8 dígitos, letras, números e caracteres especiais."
          />
        </Field>
        <Field label="Confirmar Senha" className="mb-5 lg:mb-10">
          <InputPassword
            {...form.register("password_confirmation", {
              required: "Campo obrigatório",
            })}
            placeholder="Deve ser a mesma senha informada acima"
          />
        </Field>
      </div>

      <Button
        className="h-10 w-60 max-w-full my-5"
        loading={mutation.isPending}
        type="submit"
        variant="primary-1"
      >
        Enviar nova senha
      </Button>
      <Button
        className="h-10 w-60 max-w-full mb-10"
        asChild
        variant="primary-1"
      >
        <Link to="/entrar">Voltar para login</Link>
      </Button>
    </form>
  );
}
